import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const fetchDistricts = async () => (await api.get("/districts")).data;
export const fetchDistrict = async (slug) => (await api.get(`/districts/${slug}`)).data;
export const fetchActivity = async (slug) => (await api.get(`/districts/${slug}/activity`)).data;
export const search = async (q, district) =>
    (await api.get("/search", { params: { q, district } })).data;
